// @ts-nocheck
/* eslint-disable */
import * as React from 'react';
import {
  Alert,
  ActionButton,
  Card,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Typography,
  message,
} from '@ui';
import '@lib/api';
import '@lib/auth';
import '@lib/brand';
import '@lib/utils';
import '@lib/i18n';
import '@ui';
const { icons } = window as any;

('use strict');

const t = (key, params) => (window.i18nModule ? window.i18nModule.t(key, params) : key);

const { useState, useEffect } = React;
const { DeleteOutlined, EditOutlined, PlusOutlined, ReloadOutlined, GlobalOutlined } = icons;
const { Text } = Typography;

const API_BASE = window.location.origin + '/api';

function WebForwardManagement() {
  const [routes, setRoutes] = useState([]);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingRoute, setEditingRoute] = useState(null);
  const [form] = Form.useForm();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    loadRoutes();
    loadDevices();
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const loadRoutes = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${API_BASE}/forward-routes`);
      const data = await resp.json();
      if (resp.ok) {
        setRoutes(data.routes || []);
      } else {
        message.error(data.error || 'Failed to load routes');
      }
    } catch (e) {
      message.error(t('common.networkError') + ': ' + e.message);
    } finally {
      setLoading(false);
    }
  };

  const loadDevices = async () => {
    try {
      const resp = await fetch(`${API_BASE}/devices`);
      const data = await resp.json();
      if (resp.ok) {
        setDevices(data.devices || []);
      }
    } catch {
      // ignore
    }
  };

  const handleAdd = () => {
    setEditingRoute(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (route) => {
    setEditingRoute(route);
    form.setFieldsValue({
      subdomain: route.subdomain,
      device_id: route.device_id,
      port: route.port,
      path_prefix: route.path_prefix,
    });
    setModalVisible(true);
  };

  const handleDelete = async (route) => {
    Modal.confirm({
      title: 'Delete route',
      content: `Delete "${route.subdomain}.ops.pidoc.cn"?`,
      onOk: async () => {
        try {
          const resp = await fetch(`${API_BASE}/forward-routes/${route.id}`, { method: 'DELETE' });
          if (resp.ok) {
            message.success('Deleted');
            loadRoutes();
          } else {
            const data = await resp.json();
            message.error(data.error || 'Delete failed');
          }
        } catch (e) {
          message.error(t('common.networkError') + ': ' + e.message);
        }
      },
    });
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const isEdit = !!editingRoute;
      const url = isEdit
        ? `${API_BASE}/forward-routes/${editingRoute.id}`
        : `${API_BASE}/forward-routes`;
      const method = isEdit ? 'PUT' : 'POST';

      const resp = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });
      const data = await resp.json();
      if (resp.ok) {
        message.success(isEdit ? 'Updated' : 'Created');
        setModalVisible(false);
        loadRoutes();
      } else {
        message.error(data.error || 'Operation failed');
      }
    } catch {
      // validation error
    }
  };

  const columns = [
    {
      title: t('forward.subdomain'),
      dataIndex: 'subdomain',
      key: 'subdomain',
      width: 220,
      render: (text) => {
        const opsDomain = window.PidocBrand?.opsDomain || 'ops.pidoc.cn';
        const url = `https://${text}.${opsDomain}`;
        return <a href={url} target="_blank" rel="noreferrer" className="text-primary-400 hover:text-primary-300">{url}</a>;
      },
    },
    {
      title: t('forward.target'),
      key: 'target',
      width: 200,
      render: (_, record) => `${record.device_alias || '-'}:${record.port}`,
    },
    {
      title: t('forward.pathPrefix'),
      dataIndex: 'path_prefix',
      key: 'path_prefix',
      width: 120,
      render: (text) => (text && text !== '/' ? <Tag>{text}</Tag> : '/'),
    },
    {
      title: t('common.operation'),
      key: 'action',
      width: 200,
      render: (_, record) => (
        <Space size="small">
          <ActionButton action="edit" onClick={() => handleEdit(record)} />
          <ActionButton action="delete" onClick={() => handleDelete(record)} />
        </Space>
      ),
    },
  ];

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Card
        title={t('forward.webForward')}
        extra={
          <Space size={isMobile ? 'small' : 'middle'}>
            <ActionButton action="refresh" iconOnly={isMobile} onClick={loadRoutes} />
            <ActionButton action="add" variant="primary" iconOnly={isMobile} onClick={handleAdd} />
          </Space>
        }
      >
        <Table
          columns={columns}
          dataSource={routes}
          rowKey="id"
          loading={loading}
          pagination={{
            pageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            showTotal: (total) => t('common.totalRecords', { count: total }),
          }}
          scroll={{ x: isMobile ? 600 : 900 }}
          size={isMobile ? 'small' : 'middle'}
        />
        <Alert
          type="info"
          showIcon
          message={t('forward.forwardHint')}
          style={{ marginTop: 16 }}
        />
      </Card>

      <Modal
        title={editingRoute ? t('forward.editRoute') : t('forward.addRoute')}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleSubmit}
        okText={t('common.confirm')}
        cancelText={t('common.cancel')}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label={t('forward.subdomain')}
            name="subdomain"
            rules={[
              { required: true, message: t('forward.subdomainRequired') },
              { pattern: /^[a-z][a-z0-9-]{0,19}$/, message: t('forward.subdomainPattern') },
            ]}
          >
            <Input
              placeholder="subdomain"
              disabled={!!editingRoute}
              suffix={<span className="text-dark-500 text-xs">.ops.pidoc.cn</span>}
            />
          </Form.Item>
          <Form.Item
            label={t('forward.targetDevice')}
            name="device_id"
            rules={[{ required: true, message: 'device is required' }]}
          >
            <Select
              placeholder={t('forward.selectDevice')}
              options={devices.map((d) => ({
                label: `${d.device_alias || '-'}(${d.serial_number || d.id})`,
                value: d.id,
              }))}
            />
          </Form.Item>
          <Form.Item
            label={t('forward.targetPort')}
            name="port"
            rules={[{ required: true, message: 'port is required' }]}
          >
            <InputNumber min={1} max={65535} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            label={t('forward.pathPrefix')}
            name="path_prefix"
          >
            <Input placeholder="/ (default, leave empty)" />
          </Form.Item>
        </Form>
      </Modal>
    </Space>
  );
}

export { WebForwardManagement };

// ── MC 转发配置管理 ──────────────────────────────────────

function MCForwardManagement({ devices }) {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingRoute, setEditingRoute] = useState(null);
  const [form] = Form.useForm();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    loadRoutes();
    const h = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  const loadRoutes = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${API_BASE}/mc-forward-routes`);
      const data = await resp.json();
      if (resp.ok) setRoutes(data.data || []);
      else message.error(data.message || 'Failed to load MC routes');
    } catch (e) {
      message.error(t('common.networkError') + ': ' + e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingRoute(null);
    form.resetFields();
    form.setFieldsValue({ port: 25565 });
    setModalVisible(true);
  };

  const handleEdit = (route) => {
    setEditingRoute(route);
    form.setFieldsValue({ subdomain: route.subdomain, device_id: route.device_id, port: route.port });
    setModalVisible(true);
  };

  const handleDelete = (route) => {
    Modal.confirm({
      title: t('forward.mcDeleteTitle'),
      content: t('forward.mcDeleteConfirm', { subdomain: route.subdomain }),
      onOk: async () => {
        try {
          const resp = await fetch(`${API_BASE}/mc-forward-routes/${route.id}`, { method: 'DELETE' });
          if (resp.ok) { message.success(t('common.success')); loadRoutes(); }
          else { const d = await resp.json(); message.error(d.message || t('common.error')); }
        } catch (e) { message.error(t('common.networkError')); }
      },
    });
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const isEdit = !!editingRoute;
      const url = isEdit ? `${API_BASE}/mc-forward-routes/${editingRoute.id}` : `${API_BASE}/mc-forward-routes`;
      const method = isEdit ? 'PUT' : 'POST';
      if (!isEdit) values.subdomain = values.subdomain?.toLowerCase();
      const resp = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });
      const data = await resp.json();
      if (resp.ok) {
        message.success(isEdit ? t('common.success') : t('common.success'));
        setModalVisible(false);
        loadRoutes();
      } else {
        message.error(data.message || t('common.error'));
      }
    } catch { /* validation */ }
  };

  const columns = [
    {
      title: t('forward.mcServerAddress'),
      dataIndex: 'subdomain',
      key: 'subdomain',
      width: 240,
      render: (text) => {
        const mcDomain = window.PidocBrand?.mcDomain || 'mc.pidoc.cn';
        return <Text copyable>{`${text}.${mcDomain}`}</Text>;
      },
    },
    {
      title: t('forward.mcTarget'),
      key: 'target',
      width: 200,
      render: (_, r) => `${r.device_alias || '-'}:${r.port}`,
    },
    {
      title: t('common.operation'),
      key: 'action',
      width: 200,
      render: (_, record) => (
        <Space size="small">
          <ActionButton action="edit" onClick={() => handleEdit(record)} />
          <ActionButton action="delete" onClick={() => handleDelete(record)} />
        </Space>
      ),
    },
  ];

  return (
    <Card
      title={t('forward.mcForward')}
      extra={
        <Space size={isMobile ? 'small' : 'middle'}>
          <ActionButton action="refresh" iconOnly={isMobile} onClick={loadRoutes} />
          <ActionButton action="add" variant="primary" iconOnly={isMobile} onClick={handleAdd} />
        </Space>
      }
    >
      <Table
        columns={columns}
        dataSource={routes}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 20, showTotal: (total) => t('common.totalRecords', { count: total }) }}
        scroll={{ x: isMobile ? 500 : 700 }}
        size={isMobile ? 'small' : 'middle'}
      />
      <Alert
        type="info"
        showIcon
        message={t('forward.mcHint')}
        style={{ marginTop: 16 }}
      />

      <Modal
        title={editingRoute ? t('forward.mcEditModal') : t('forward.mcAddModal')}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleSubmit}
        okText={t('common.confirm')}
        cancelText={t('common.cancel')}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label={t('forward.mcSubdomainLabel')}
            name="subdomain"
            rules={[
              { required: true, message: t('forward.mcSubdomainRequired') },
              { pattern: /^[a-z][a-z0-9-]{0,19}$/, message: t('forward.mcSubdomainPattern') },
            ]}
          >
            <Input
              placeholder="myserver"
              disabled={!!editingRoute}
              suffix={<span className="text-dark-500 text-xs">.mc.pidoc.cn</span>}
            />
          </Form.Item>
          <Form.Item
            label={t('forward.mcTargetDevice')}
            name="device_id"
            rules={[{ required: true, message: t('forward.mcTargetDeviceRequired') }]}
          >
            <Select
              placeholder={t('forward.mcSelectDevice')}
              options={(devices || []).map((d) => ({
                label: `${d.device_alias || '-'}(${d.serial_number || d.id})`,
                value: d.id,
              }))}
            />
          </Form.Item>
          <Form.Item
            label={t('forward.mcTargetPort')}
            name="port"
            rules={[{ required: true, message: t('forward.mcTargetPortRequired') }]}
          >
            <InputNumber min={1} max={65535} style={{ width: '100%' }} placeholder="25565" />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
}

// ── 应用转发页面总入口（HTTP转发 + MC转发）──────────────────

function ForwardManagement() {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/devices`)
      .then((r) => r.json())
      .then((d) => setDevices(d.devices || []))
      .catch(() => {});
  }, []);

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <WebForwardManagement />
      <MCForwardManagement devices={devices} />
    </Space>
  );
}

export { ForwardManagement };
